import * as userSliceActions from "./slices/user";
import * as notificationSlice from "./slices/notification";
import * as sellerMenuSlice from "./slices/sellerMenu";
import * as buyerMenuSlice from "./slices/buyerMenu"
import * as sellerAssetSlice from "./slices/sellerAssetSlice"
import * as buyerAssetSlice from "./slices/buyerAssetSlice"
import * as aiChatSlice from "./slices/aiChatSlice" // Claude: unified AI chat history 23-03-2026


const actions = {
  user: {
    set: userSliceActions.setUser,
    logout: userSliceActions.logout,
    changeToken: userSliceActions.changeToken,
    setVerificationStatus: userSliceActions.setVerificationStatus, // Claude: refresh without re-login 10-03-2026
  },
  notification: {
    get: notificationSlice.setNotifications,
    setLoading: notificationSlice.setLoading,
  },
  sellerMenu: {
    set: sellerMenuSlice.setActiveMenu
  },
  buyerMenu: {
    set: buyerMenuSlice.setActiveMenu
  },
  sellerAssets:{
    setAssets: sellerAssetSlice.setAssets,
    setLink: sellerAssetSlice.setLink,
    setTitle: sellerAssetSlice.setTitle,
    resetForm: sellerAssetSlice.resetForm
  },
  buyerAssets: {
    setAssets: buyerAssetSlice.setAssets,
    setLink: buyerAssetSlice.setLink,
    setTitle: buyerAssetSlice.setTitle,
    resetForm: buyerAssetSlice.resetForm,
  },
  aiChat: {
    addBuyerMessage: aiChatSlice.addBuyerMessage,
    addSellerMessage: aiChatSlice.addSellerMessage,
    setBuyerMessages: aiChatSlice.setBuyerMessages,
    setSellerMessages: aiChatSlice.setSellerMessages,
    clearBuyerMessages: aiChatSlice.clearBuyerMessages,
    clearSellerMessages: aiChatSlice.clearSellerMessages,
  },
};

export default actions;
